import { rem } from 'polished';
import range from 'lodash/range';

const textStyles = {
  intro: {
    marginTop: '100px',
    fontSize: '5rem',
    color: '#222',
    fontWeight: '100',
  },
};

const breakpoints = [
  rem('800px'),
  rem('1080px'),
  rem('1280px'),
];

const mediaQueries = breakpoints.map(n => `@media screen and (min-width: ${n})`);

const fontSizes = {
  xs: rem('13px'),
  sm: rem('15px'),
  base: rem('16px'),
  lg: rem('18px'),
  xl: rem('22px'),
  '2xl': rem('26px'),
  '3xl': rem('36px'),
  '4xl': rem('46px'),
};

const lineHeights = {
  tight: 1,
  normal: 1.35,
  loose: 1.5,
};

const colors = {
  brand: {
    primary: '#008e38',
    secondary: '#F8C749',
  },
  ui: {
    text: '#222222',
    link: '#0B9443',
    linkHover: '#037532',
  },
};

const maxWidths = {
  default: rem('1280px'),
};

const gutters = {
  default: 3,
};

const space = range(0, 129, 4).map(i => rem(`${i}px`));

const buttons = {
  primary: {
    color: 'white',
    backgroundColor: 'blue',
    '&:hover': {
      backgroundColor: 'black',
    },
  },
};

export default {
  textStyles,
  colors,
  buttons,
  gutters,
  space,
  maxWidths,
  fontSizes,
  lineHeights,
  breakpoints,
  mediaQueries,
};



// WEBPACK FOOTER //
// ./src/style/theme.js